import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Collapse } from 'src/ui/components/collapse/sports/04/Collapse';
import {
    EventHeaderCaption,
    EventHeaderCaptionName,
} from 'src/domains/sportsbook/webview/components/competitionHeader/CompetitionHeader.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface EventGroupHeaderPropsType {
    dataTest?: string;
    isOutrightEvent: boolean;
    label: string;
    onToggle: () => void;
    isOpen: boolean;
    selections: Array<string>;
}

export const CompetitionHeader = observer('CompetitionHeader', (props: EventGroupHeaderPropsType) => {
    const { dataTest, isOutrightEvent, label, onToggle, isOpen, selections } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    return (
        <Collapse
            dataTest={dataTest}
            isOpen={isOpen}
            handleToggle={onToggle}
            title={label}
        >
            {isOutrightEvent === false &&
                selections.map((name, key) => (
                    <EventHeaderCaption
                        key={key}
                        variant={configState.componentVariants.sportsbookVariant}
                    >
                        <EventHeaderCaptionName>{name.charAt(0).toUpperCase()}</EventHeaderCaptionName>

                        <EventHeaderCaptionName>{name}</EventHeaderCaptionName>
                    </EventHeaderCaption>
                ))}
        </Collapse>
    );
});
